/**
 * The controls a page info task can point at with "Show me". A key names a
 * control, not a page, because one component often serves several pages — the
 * folder view's Upload button is the same element on Documents, a project's
 * own page and the Brief.
 */
export const PAGE_INFO_TARGETS = [
  "buildings.add",
  "buildings.search",
  "building.newProject",
  "building.buildingData",
  "layout.viewMode",
  "layout.chat",
  "buildingData.review",
  "buildingData.filter",
  "buildingData.search",
  "buildingData.history",
  "editBuilding.save",
  "dashboard.messages",
  "files.upload",
  "files.newDocument",
  "files.newFolder",
  "files.organise",
  "files.more",
  "files.search",
  "files.tree",
  "documents.views",
  "documents.filters",
  "documents.history",
  "signing.tabs",
  "signing.filter",
  "brief.start",
  "brief.confirm",
  "brief.additions",
  "brief.check",
  "brief.versions",
  "brief.history",
  "contacts.add",
  "contacts.search",
  "contacts.filter",
  "issues.newIssue",
  "issues.views",
  "issues.filters",
  "myIssues.tabs",
  "myIssues.layout",
  "notifications.filter",
  "model.picker",
  "model.tree",
  "model.section",
  "model.filters",
  "model.issues",
  "drawings.picker",
  "settings.save",
  "settings.notifications",
  "settings.chatbot",
  "settings.password",
  "org.save",
  "org.logo",
  "org.invite",
  "billing.addBuilding",
  "billing.saveDetails",
  "billing.paymentMethod",
  "buildings.expandProjects",
  "dashboard.whatsNewRange",
  "dashboard.myTasksWindow",
  "layout.projectSwitcher",
  "signing.signNow",
  "signing.search",
  "signing.download",
  "signing.checkStatus",
  "brief.suggestions",
  "model.screenshot",
  "drawings.modes",
  "drawings.measure",
  "drawings.layers",
  "drawings.createIssue",
  "drawings.export",
  "issues.protocol",
  "issues.myDisciplines",
  "issues.sort",
  "settings.photo",
  "invitations.accept",
  "connections.revoke",
  "org.refreshMembers",
  "billing.restore",
  "billing.downloadInvoice",
] as const;

export type PageInfoTargetKey = (typeof PAGE_INFO_TARGETS)[number];

export const PAGE_INFO_TARGET_ATTR = "data-page-info-target";

/**
 * Spread onto the control a page info task describes, so the dialog's
 * "Show me" can find it: `<Button {...pageInfoTarget("files.upload")}>`.
 */
export function pageInfoTarget(key: PageInfoTargetKey): { [PAGE_INFO_TARGET_ATTR]: string } {
  return { [PAGE_INFO_TARGET_ATTR]: key };
}
